import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { toMonetaryFormat } from '../../../common/Utilities';

function ActualRevenueBreakdown({
  actualBreakdown 
}) {
  const renderBreakdowns = () => {
    return (
      <>
        <Row>
          <Col className="align-center breakdown-total-revenue">
            { toMonetaryFormat(actualBreakdown.totalRevenue) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-fully-loaded-cost">
            { toMonetaryFormat(actualBreakdown.totalFullyLoadedCost) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-unloaded-cost">
            { toMonetaryFormat(actualBreakdown.totalUnloadedCost) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-external-cost">
            { toMonetaryFormat(actualBreakdown.totalExternalCost) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-cost">
            { toMonetaryFormat(actualBreakdown.totalCost) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-profit-before-tax">
            { toMonetaryFormat(actualBreakdown.profitBeforeTax) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-profit-after-tax">
            { toMonetaryFormat(actualBreakdown.profitNetofTax) }
          </Col>
        </Row>
      </>
    )
  }

  return (
    <Row>
      <Col>
        {renderBreakdowns()}
      </Col>
    </Row>
  )
}


export default ActualRevenueBreakdown